import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsAvailableForSplit } from '@/entities/parcels/modules/api/parcels';

export const useParcelsAvailableForSplit = () =>
  useFetch({
    api: apiParcelsAvailableForSplit,
    keywords: queryKeys.parcels.availableForSplit,
    staleTime: 60_000,
  });
